import type {
  ModelBankDetails,
  ModelBillingAddress,
  ModelCommunication,
  ModelMerchantAccountSettings,
  ModelMerchantResponse,
  ModelNotification,
  ModelNotificationPercentage,
} from '@layup/api-sdk';

export type OrganisationSettings = {
  name: string;
  tradingName: string;
  vatNo: string;
  registeredEntity: string;
  supportMobile: string;
  supportEmail: string;
  settlementBatchReferencePrefix: string;
  merchantTermsLink: string;
  merchantTerms?: {
    pdf: string;
    url: string;
  };
  billingAddress: ModelBillingAddress;
};

export type ClientCommunication = ModelCommunication;

export type NotificationSettings = {
  settlements: ModelNotification;
  invoices: ModelNotification;
  newOrder: ModelNotification;
  amendmentOrder: ModelNotification;
  expiredOrder: ModelNotification;
  suspendedOrder: ModelNotification;
  cancelledOrder: ModelNotification;
  cancellationRequest: ModelNotification;
  completedOrder_75: ModelNotificationPercentage;
  completedOrder: ModelNotification;
  successfulPayment: ModelNotification;
  failedPayment: ModelNotification;
  missedPayment: ModelNotification;
  refunds: ModelNotification;
  transfers: ModelNotification;
};

export type BillingSettings = {
  settlementFrequency: string;
  percFee: number;
  settlementType: string;
  priceList: any;
  accountSettings: ModelMerchantAccountSettings;
  numberOfAddedUsers: number;
  settlementDay: number;
  paymentPlans: ModelMerchantResponse['paymentPlans'];
  features: ModelMerchantResponse['features'];
  accountType: string;
  name: string;
  supportMobile: string;
  registeredEntity: string;
  bankDetails: ModelBankDetails;
};

export type BillingChangeRequest = {
  merchantName: string;
  userName: string;
  userEmail: string;
  merchantId: string;
  merchantContactNumber: string;
  message: string;
  type: string;
};

export type DebitOrderMandateCreateRequest = {
  merchantId: string;
  reference: string;
  holderName: string;
  holderSurname: string;
  contact: string;
  accountType: string;
  accountNumber: string;
  branchCode: string;
  identificationType: string;
  identificationNumber: string;
  bankName: string;
};

export const capitalize = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const BANK_ACCOUNT_TYPES = [
  { value: 'Savings', key: 'Savings' },
  { value: 'Current', key: 'Current' },
  { value: 'Transmission', key: 'Transmission' },
];
